import React, { useState, useEffect } from "react";
import profile from "../../assets/profilePicture.png";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../../redux/actions/userActions";
import styles from "./Register.module.css";
import { Link } from "react-router-dom";
import validator from "validator";
import { Alert } from "reactstrap";
import { firebase } from "../../firebase";

const Register = ({ history }) => {
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { loadingRegister, userInfo, errorRegister } = userLogin;

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  // useEffect(() => {
  //   if (userInfo) {
  //     history.push("/");
  //   }
  // }, [history, userInfo]);

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem('phone', phone)
    dispatch(register(name, email, phone, history));
  };

  return (
    <div className={styles.container}>
      <header>
        <div className={styles.topHeader}>
          <Link to="/login">
            <i className={styles.backIcon + " fas fa-chevron-left"}></i>
          </Link>
          <h1>Register</h1>
        </div>
      </header>
      <main>
        <form onSubmit={handleSubmit}>
          <div className={styles.imgContainer}>
            <i className={styles.image + " fas fa-image"}></i>
            <img src={profile} alt="select-user-pic" />
            <i className={styles.camera + " fas fa-camera"}></i>
          </div>

          <div className={styles.errorField}>
            {errorRegister && (
              <Alert color="danger">Something went wrong !</Alert>
            )}
          </div>

          <div className={styles.fieldsContainer}>
            <div className={styles.field}>
              <label>Full Name</label>
              <input
                type="text"
                placeholder="Enter Name"
                value={name}
                autoComplete="off"
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className={styles.field}>
              <label>Email Address</label>
              <input
                error
                type="email"
                required={true}
                placeholder="Enter Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {!validator.isEmail(email) && (
                <>
                  <p style={{ color: "red", margin: "10px " }}>
                    Enter valid Email !
                  </p>
                </>
              )}
            </div>

            <div className={styles.field}>
              <label>Phone Number</label>
              <input
                type="number"
                name="phone"
                placeholder="Enter phone number"
                value={phone}
                autoComplete="off"
                onChange={(e) => setPhone(e.target.value)}
                required
              />
              {!validator.isLength(phone, { min: 5 }) && (
                <>
                  <p style={{ color: "red", margin: "10px " }}>
                    Enter valid Number !
                  </p>
                </>
              )}
            </div>
            <button type="submit">
              {loadingRegister ? (
                <span>Loading...</span>
              ) : (
                <span>Continue</span>
              )}
            </button>
          </div>
          
        </form>
      </main>
    </div>
  );
};

export default Register;

{
  /* <div className={styles.field}>
            <label>Country</label>
            <input
              type="text"
              name="country"
              placeholder="Enter Country"
              value={country}
              autoComplete="off"
              onChange={(e) => setCountry(e.target.value)}
            />
          </div> */
}
